import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import Button from "../button";
import { ButtonSize, ButtonVariant } from "../button/types";

export function QuickLinks({
  className,
  onClose,
}: {
  className?: string;
  onClose?: () => void;
}) {
  const { t } = useTranslation("links");

  const navigate = useNavigate();
  const { user, configurations } = useContext(AuthContext);

  const productType = configurations?.productType;
  const isBLUE = productType === "BLUE";
  const includesGuide = configurations.includesGuide && !isBLUE;

  const includesConsulting = configurations.includesGuide && isBLUE;
  const includesCommunity = configurations.includesCommunity;
  const includesCreditSection = configurations?.includesCreditSection;

  const handleClickGuide = async () => {
    if (onClose) onClose();
    navigate(`/profile/guide`);
  };

  const handleClickConsulting = async () => {
    if (onClose) onClose();
    navigate(`/profile/consulting`);
  };

  const handleClickWebinar = async () => {
    if (onClose) onClose();
    navigate(`/community`);
  };

  const handleClickCredits = async () => {
    if (onClose) onClose();
    navigate(`/profile/credits`);
  };

  if (
    !includesCommunity &&
    !(includesGuide || includesConsulting) &&
    !includesCreditSection
  ) {
    return null;
  }

  return (
    <>
      <div
        className={`flex flex-col w-full p-6 text-Yellow-light bg-white lg:bg-Yellow-super-light text-black rounded-lg ${className}`}
      >
        <h2 className="mb-4 hidden font-semibold hidden lg:flex text-xl">
          {t("quick-links")}
        </h2>

        <h3 className="mb-4 lg:hidden font-medium flex font-[700] text-[16px] leading-[19.2px]">
          {t("quick-links")}
        </h3>

        <hr className="h-[1px] bg-[#A7B6C5] lg:bg-Gray-dark border-0 mb-4" />

        {includesCommunity && (
          <Button
            onClick={handleClickWebinar}
            className="w-full mb-2 text-[16px] font-[400] leading-[24px]"
            variant={ButtonVariant.SECONDARY}
            size={ButtonSize.SMALL}
          >
            {t("webinars")}
          </Button>
        )}

        {includesGuide && (
          <Button
            onClick={handleClickGuide}
            className="w-full mb-2 text-[16px] font-[400] leading-[24px]"
            variant={ButtonVariant.SECONDARY}
            size={ButtonSize.SMALL}
          >
            {t("guide")}
          </Button>
        )}

        {includesConsulting && (
          <Button
            onClick={handleClickConsulting}
            className="w-full mb-2 text-[16px] font-[400] leading-[24px]"
            variant={ButtonVariant.SECONDARY}
            size={ButtonSize.SMALL}
          >
            {t("consulting")}
          </Button>
        )}

        {includesCreditSection && (
          <Button
            onClick={handleClickCredits}
            className="w-full text-[16px] font-[400] leading-[24px]"
            variant={ButtonVariant.SECONDARY}
            size={ButtonSize.SMALL}
          >
            {t("my-credits")}
          </Button>
        )}
      </div>
    </>
  );
}
